import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

/**
 * Standard section wrapper used on every MyAgentProfile section.
 * Header layout: icon + title (+ optional subtitle) on the left; optional
 * pencil-edit button + custom action slot on the right. Body is a flexible
 * children area with consistent padding rhythm.
 *
 * Use the `onEdit` prop for the standard pencil button. Use `headerAction`
 * for any other right-aligned controls (e.g. "See all" link).
 */
const SectionCard = ({
    icon,
    title,
    subtitle,
    onEdit,
    editLabel = 'Edit',
    headerAction,
    className = '',
    bodyPadding = 'p-3',
    children,
}) => (
    <Card
        className={`shadow-1 ${className}`}
        pt={{
            body: { className: bodyPadding },
            content: { className: 'p-0' },
        }}
    >
        {(icon || title || onEdit || headerAction) && (
            <div className="flex align-items-center justify-content-between mb-3 gap-2">
                <div className="flex align-items-center gap-2 min-w-0">
                    {icon && (
                        <i
                            className={`pi ${icon} text-primary flex-shrink-0`}
                            aria-hidden="true"
                        />
                    )}
                    <div className="min-w-0">
                        {title && (
                            <h3 className="text-900 font-semibold text-sm m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                {title}
                            </h3>
                        )}
                        {subtitle && (
                            <p className="text-500 text-xs m-0 mt-1">{subtitle}</p>
                        )}
                    </div>
                </div>
                <div className="flex align-items-center gap-1 flex-shrink-0">
                    {headerAction}
                    {onEdit && (
                        <Button
                            icon="pi pi-pencil"
                            text
                            rounded
                            size="small"
                            onClick={onEdit}
                            tooltip={editLabel}
                            tooltipOptions={{ position: 'left' }}
                            aria-label={`${editLabel} ${title || 'section'}`}
                        />
                    )}
                </div>
            </div>
        )}
        {children}
    </Card>
);

export default SectionCard;
